export default __webpack_public_path__ + "static/media/ScrollThree.2f3d6ee3.png";